import { rbac } from "config/rbac";
import { useCheckPerms } from "./useCheckPerms";

export const useIsPrintUser = () => useCheckPerms(rbac.managePrint);
